import { Provider } from '@angular/core';
import { FirmwareApiService } from '@kempoweroyj/ngx-firmware-api-client';
import { FirmwareService } from 'shared/firmware/firmware.service';
import { UpdateRegistryApiService } from '@kempoweroyj/ngx-update-registry-api-client';
import { ReportingApiService } from '@kempoweroyj/ngx-reporting-api-client';
import { TransactionsApiService } from '@kempoweroyj/ngx-transactions-api-client';
import {
    FIRMWARE_API_SERVICE,
    FIRMWARE_SERVICE,
    UPDATE_REGISTRY_API_SERVICE,
    REPORTING_API_SERVICE,
    TRANSACTIONS_API_SERVICE,
} from './builder-tokens';

/**
 * Provides external API services to section builders using InjectionTokens.
 * Import this array in your module's providers to enable all builder features.
 *
 * @example
 * ```typescript
 * @NgModule({
 *   providers: [
 *     ...SECTION_BUILDER_PROVIDERS
 *   ]
 * })
 * export class AppModule { }
 * ```
 */
export const SECTION_BUILDER_PROVIDERS: Provider[] = [
    { provide: FIRMWARE_API_SERVICE, useExisting: FirmwareApiService },
    { provide: FIRMWARE_SERVICE, useExisting: FirmwareService },
    { provide: UPDATE_REGISTRY_API_SERVICE, useExisting: UpdateRegistryApiService },
    { provide: REPORTING_API_SERVICE, useExisting: ReportingApiService },
    { provide: TRANSACTIONS_API_SERVICE, useExisting: TransactionsApiService },
];
